import React from 'react';
import { 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  Facebook, 
  Instagram, 
  Twitter, 
  Linkedin,
  Youtube,
  Heart,
  ChevronRight,
  Award,
  Shield,
  Activity
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About Us', href: '#about' },
    { name: 'Our Services', href: '#services' },
    { name: 'Medical Procedures', href: '#procedures' },
    { name: 'Our Doctors', href: '#doctors' },
    { name: 'Patient Testimonials', href: '#testimonials' },
    { name: 'Health Blog', href: '#blog' }
  ];

  const services = [
    { name: 'Pulmonology Care', href: '#pulmonology' },
    { name: 'Cardiology', href: '#cardiology' },
    { name: 'Critical Care', href: '#critical-care' },
    { name: 'General Medicine', href: '#general-medicine' },
    { name: 'Diagnostics', href: '#diagnostics' },
    { name: 'Preventive Care', href: '#preventive' },
    {name: 'Gynaecology', href: '#gynaecology' },
  ];

  const socialLinks = [
    // { icon: <Facebook size={20} />, href: '', name: 'Facebook' },
    { icon: <Instagram size={20} />, href: 'https://www.instagram.com/vayulungcare?igsh=cnFpZDZtNzEwMHVv', name: 'Instagram' },
    // { icon: <Twitter size={20} />, href: '#', name: 'Twitter' },
    // { icon: <Linkedin size={20} />, href: '#', name: 'LinkedIn' },
    { icon: <Youtube size={20} />, href: 'https://youtube.com/@vayulungcare?si=Qm7gizDqR5zF9M4y', name: 'YouTube' }
  ];

  return (
    <>
      <style>{`
        .footer {
          background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 50%, #1B4965 100%);
          color: white;
          position: relative;
          overflow: hidden;
        }

        .footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 6px;
          background: linear-gradient(90deg, #E86A33, #FF9B6E, #E86A33);
        }

        .footer-pattern {
          position: absolute;
          top: 0;
          right: 0;
          width: 50%;
          height: 100%;
          opacity: 0.05;
          background-image: radial-gradient(circle, white 1px, transparent 1px);
          background-size: 30px 30px;
          pointer-events: none;
        }

        .footer-main {
          max-width: 1400px;
          margin: 0 auto;
          padding: 5rem 2rem 3rem;
          display: grid;
          grid-template-columns: 2fr 1fr 1fr 1.5fr;
          gap: 4rem;
          position: relative;
          z-index: 1;
        }

        .footer-brand {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        .footer-logo-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 800;
          font-size: 1.8rem;
          box-shadow: 0 8px 25px rgba(232, 106, 51, 0.3);
        }

        .footer-logo-text h3 {
          font-family: 'Playfair Display', serif;
          font-size: 1.8rem;
          font-weight: 700;
          margin-bottom: 0.2rem;
        }

        .footer-logo-text p {
          font-size: 0.85rem;
          opacity: 0.9;
          font-weight: 500;
        }

        .footer-description {
          font-size: 0.95rem;
          line-height: 1.8;
          opacity: 0.9;
          margin-bottom: 1.5rem;
        }

        .footer-certifications {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .cert-badge {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          padding: 0.6rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .cert-badge:hover {
          background: rgba(232, 106, 51, 0.2);
          border-color: #E86A33;
        }

        .footer-section h4 {
          font-size: 1.3rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
          position: relative;
          padding-bottom: 0.8rem;
        }

        .footer-section h4::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 50px;
          height: 3px;
          background: linear-gradient(90deg, #E86A33, #FF9B6E);
          border-radius: 2px;
        }

        .footer-links {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }

        .footer-link {
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          font-size: 0.95rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s ease;
          padding: 0.3rem 0;
        }

        .footer-link:hover {
          color: #FF9B6E;
          padding-left: 0.5rem;
        }

        .footer-link svg {
          flex-shrink: 0;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .footer-link:hover svg {
          opacity: 1;
        }

        .footer-contact {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .contact-info-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
        }

        .contact-icon {
          width: 45px;
          height: 45px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #FF9B6E;
          flex-shrink: 0;
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .contact-info-item:hover .contact-icon {
          background: rgba(232, 106, 51, 0.2);
          border-color: #E86A33;
          transform: scale(1.05);
        }

        .contact-details {
          flex: 1;
        }

        .contact-label {
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 1px;
          opacity: 0.7;
          margin-bottom: 0.3rem;
          font-weight: 600;
        }

        .contact-value {
          font-size: 0.95rem;
          font-weight: 500;
          line-height: 1.6;
        }

        .contact-value a {
          color: white;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-value a:hover {
          color: #FF9B6E;
        }

        .footer-social {
          margin-top: 2rem;
        }

        .social-links {
          display: flex;
          gap: 1rem;
          margin-top: 1rem;
        }

        .social-link {
          width: 45px;
          height: 45px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .social-link:hover {
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border-color: #E86A33;
          transform: translateY(-3px);
          box-shadow: 0 5px 20px rgba(232, 106, 51, 0.4);
        }

        .footer-map-section {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem 3rem;
          position: relative;
          z-index: 1;
        }

        .footer-map-container {
          background: rgba(255, 255, 255, 0.08);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 20px;
          padding: 2rem;
          overflow: hidden;
        }

        .map-header {
          margin-bottom: 1.5rem;
        }

        .map-title {
          font-size: 1.5rem;
          font-weight: 700;
          font-family: 'Playfair Display', serif;
          margin-bottom: 0.5rem;
        }

        .map-description {
          font-size: 0.95rem;
          opacity: 0.85;
          line-height: 1.6;
        }

        .map-frame-wrapper {
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
          border: 2px solid rgba(255, 255, 255, 0.1);
        }

        .map-frame-wrapper iframe {
          width: 100%;
          height: 400px;
          border: none;
          display: block;
        }

        .footer-newsletter {
          background: rgba(255, 255, 255, 0.08);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 20px;
          padding: 2rem;
        }

        .newsletter-title {
          font-size: 1.2rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }

        .newsletter-description {
          font-size: 0.9rem;
          opacity: 0.85;
          margin-bottom: 1.5rem;
        }

        .newsletter-form {
          display: flex;
          gap: 0.5rem;
        }

        .newsletter-input {
          flex: 1;
          padding: 0.9rem 1.2rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 50px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          color: white;
          font-size: 0.95rem;
          outline: none;
          transition: all 0.3s ease;
        }

        .newsletter-input::placeholder {
          color: rgba(255, 255, 255, 0.6);
        }

        .newsletter-input:focus {
          background: rgba(255, 255, 255, 0.15);
          border-color: #E86A33;
        }

        .newsletter-btn {
          padding: 0.9rem 2rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border: none;
          border-radius: 50px;
          color: white;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
        }

        .newsletter-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(232, 106, 51, 0.5);
        }

        .footer-bottom {
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem 2rem 2.5rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1.5rem;
          position: relative;
          z-index: 1;
        }

        .footer-copyright {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          opacity: 0.85;
        }

        .footer-copyright .heart {
          color: #E86A33;
          animation: heartbeat 1.5s ease-in-out infinite;
        }

        @keyframes heartbeat {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

        .footer-legal {
          display: flex;
          gap: 2rem;
        }

        .legal-link {
          color: rgba(255, 255, 255, 0.85);
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.3s ease;
        }

        .legal-link:hover {
          color: #FF9B6E;
        }

        .footer-credits {
          font-size: 0.85rem;
          opacity: 0.7;
        }

        .footer-credits a {
          color: #FF9B6E;
          text-decoration: none;
          font-weight: 600;
          transition: opacity 0.3s ease;
        }

        .footer-credits a:hover {
          opacity: 0.8;
        }

        @media (max-width: 1200px) {
          .footer-main {
            grid-template-columns: 1fr 1fr;
            gap: 3rem;
          }
        }

        @media (max-width: 768px) {
          .footer-main {
            grid-template-columns: 1fr;
            gap: 3rem;
            padding: 3rem 1.5rem 2rem;
          }

          .footer-bottom {
            flex-direction: column;
            text-align: center;
            padding: 1.5rem;
          }

          .footer-legal {
            flex-direction: column;
            gap: 1rem;
          }

          .newsletter-form {
            flex-direction: column;
          }

          .newsletter-btn {
            justify-content: center;
          }

          .footer-map-section {
            padding: 0 1.5rem 2rem;
          }

          .footer-map-container {
            padding: 1.5rem;
          }

          .map-frame-wrapper iframe {
            height: 300px;
          }
        }
      `}</style>

      <footer className="footer">
        <div className="footer-pattern"></div>

        <div className="footer-main">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-icon">V</div>
              <div className="footer-logo-text">
                <h3>VAYU Lung Care</h3>
                <p>Multi-Speciality Clinics</p>
              </div>
            </div>
            <p className="footer-description">
              Leading healthcare provider in Hyderabad, dedicated to delivering comprehensive medical services with a focus on respiratory care and patient well-being. Trusted by thousands of families for over 15 years.
            </p>
            <div className="footer-certifications">
              <div className="cert-badge">
                <Award size={16} />
                <span>Certified</span>
              </div>
              <div className="cert-badge">
                <Shield size={16} />
                <span>Accredited</span>
              </div>
              <div className="cert-badge">
                <Activity size={16} />
                <span>ISO 9001:2015</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <div className="footer-links">
              {quickLinks.map((link, index) => (
                <a key={index} href={link.href} className="footer-link">
                  <ChevronRight size={16} />
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Our Services</h4>
            <div className="footer-links">
              {services.map((service, index) => (
                <a key={index} href={service.href} className="footer-link">
                  <ChevronRight size={16} />
                  {service.name}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Information */}
          <div className="footer-section">
            <h4>Get In Touch</h4>
            <div className="footer-contact">
              <div className="contact-info-item">
                <div className="contact-icon">
                  <MapPin size={20} />
                </div>
                <div className="contact-details">
                  <div className="contact-label">Visit Us</div>
                  <div className="contact-value">
                    4th Floor, Gyani Arcade,
Suncity Main Road, Hydershakote,<br />
                    Rajendranagar,
Ranga Reddy District – 500091
                  </div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <Phone size={20} />
                </div>
                <div className="contact-details">
                  <div className="contact-label">Call Us</div>
                  <div className="contact-value">
                    <a href="tel:+911234567890">+91 99891 62222</a><br />
                    {/* <a href="tel:+910987654321">+91 098 765 4321</a> */}
                  </div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <Mail size={20} />
                </div>
                <div className="contact-details">
                  <div className="contact-label">Email Us</div>
                  <div className="contact-value">
                    <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a><br />
                    {/* <a href="mailto:appointments@vayulungcare.com">appointments@vayulungcare.com</a> */}
                  </div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <Clock size={20} />
                </div>
                <div className="contact-details">
                  <div className="contact-label">Working Hours</div>
                  <div className="contact-value">
                    Mon - Sat: 9:00 AM - 9:00 PM<br />
                    Sunday: 9:00 AM - 1:00 PM
                  </div>
                </div>
              </div>
            </div>

            <div className="footer-social">
              <div className="contact-label">Follow Us</div>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index} 
                    href={social.href} 
                    className="social-link"
                    aria-label={social.name}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="footer-map-section">
          <div className="footer-map-container">
            <div className="map-header">
              <h4 className="map-title">Find Us on Map</h4>
              <p className="map-description">
                Visit our clinic at                     4th Floor, Gyani Arcade,
Suncity Main Road, Hydershakote Rajendranagar,Ranga Reddy District – 500091. 
              </p>
            </div>
            <div className="map-frame-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30501.234567890123!2d78.3273245!3d17.5235019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb97e8c381ac23%3A0xfe9ce3ea62dd7f0a!2sGyani%20Arcade%2C%20Plot%20no%205%2C%20st%20no%2C%209-5%2F39%2C%20Rajendranagar%2C%20Hydershakote%2C%20Telangana%20500091!5e0!3m2!1sen!2sin!4v1735041234567!5m2!1sen!2sin"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="VAYU Lung Care Location"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>

        {/* Newsletter Section */}
        <div style={{maxWidth: '1400px', margin: '0 auto', padding: '0 2rem 3rem'}}>
          <div className="footer-newsletter">
            <h4 className="newsletter-title">Stay Updated with Health Tips</h4>
            <p className="newsletter-description">
              Subscribe to our newsletter for health tips, medical updates, and exclusive offers
            </p>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                className="newsletter-input" 
                placeholder="Enter your email address"
                required
              />
              <button type="submit" className="newsletter-btn">
                Subscribe
                <ChevronRight size={18} />
              </button>
            </form>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <span>© {currentYear} VAYU Lung Care. All rights reserved.</span>
            <span>|</span>
            <span>Made with <Heart className="heart" size={14} fill="#E86A33" /> for better healthcare</span>
          </div>
          <div className="footer-legal">
            <a href="#privacy" className="legal-link">Privacy Policy</a>
            <a href="#terms" className="legal-link">Terms of Service</a>
            <a href="#disclaimer" className="legal-link">Medical Disclaimer</a>
          </div>
          <div className="footer-credits">
            Designed & Developed by <a href="https://www.kanactify.in/" target="_blank" rel="noopener noreferrer">kanactify</a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;